var _CUSTOM_COD_FORM_PROVINCES = {
  data: {"Antioquia":{"Apartado":true,"Bello":true,"Caldas":true,"Carepa":true,"Caucasia":true,"Chigorodo":true,"Copacabana":true,"Envigado":true,"Girardota":true,"Guarne":true,"Itagui":true,"La Ceja":true,"La Estrella":true,"Marinilla":true,"Medellin":true,"Rionegro":true,"Sabaneta":true,"Turbo":true},"Arauca":{"Arauca":true},"Atlántico":{"Baranoa":true,"Barranquilla":true,"Malambo":true,"Soledad":true},"Bolívar":{"Cartagena":true,"Magangue":true},"Boyacá":{"Chiquinquira":true,"Duitama":true,"Puerto Boyaca":true,"Sogamoso":true,"Tunja":true},"Caldas":{"Chinchina":true,"La Dorada":true,"Manizales":true,"Villamaria":true},"Caquetá":{"Florencia":true},"Casanare":{"Aguazul":true,"Tauramena":true,"Yopal":true},"Cauca":{"Popayan":true,"Santander de Quilichao":true},"Cesar":{"Aguachica":true,"Agustin Codazzi":true,"La Jagua de Ibirico":true,"Valledupar":true},"Córdoba":{"Cerete":true,"Lorica":true,"Monteria":true,"Sahagun":true,"Tierralta":true},"Cundinamarca":{"Bogota":true,"Cajica":true,"Chia":true,"Cota":true,"Facatativa":true,"Funza":true,"Fusagasuga":true,"Girardot":true,"La Calera":true,"Madrid":true,"Mosquera":true,"Soacha":true,"Sopo":true,"Tenjo":true,"Tocancipa":true,"Zipaquira":true},"Huila":{"Garzon":true,"Neiva":true,"Pitalito":true},"La Guajira":{"Maicao":true,"Riohacha":true},"Magdalena":{"Cienaga":true,"Fundacion":true,"Plato":true,"Santa Marta":true},"Meta":{"Acacias":true,"Castilla la Nueva":true,"Granada":true,"Puerto Gaitan":true,"Villavicencio":true},"Nariño":{"Ipiales":true,"Pasto":true},"Norte De Santander":{"Cucuta":true,"Ocaña":true,"Pamplona":true,"Villa del Rosario":true},"Quindío":{"Armenia":true,"Calarca":true,"Circasia":true,"La Tebaida":true},"Risaralda":{"Dosquebradas":true,"Pereira":true,"Santa Rosa de Cabal":true},"Santander":{"Barrancabermeja":true,"Bucaramanga":true,"Floridablanca":true,"Giron":true,"Piedecuesta":true,"San Gil":true},"Sucre":{"Sincelejo":true},"Tolima":{"Espinal":true,"Ibague":true},"Valle Del Cauca":{"Buenaventura":true,"Bugalagrande":true,"Caicedonia":true,"Cali":true,"Candelaria":true,"Cartago":true,"El Cerrito":true,"Florida":true,"Ginebra":true,"Guacari":true,"Guadalajara de Buga":true,"Jamundi":true,"Palmira":true,"Pradera":true,"San Pedro":true,"Sevilla":true,"Tulua":true,"Yotoco":true,"Yumbo":true,"Zarzal":true}},
  startFields: function () {
    try {
      document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value = "";
      _CUSTOM_COD_FORM_PROVINCES.onProvinceChange();
      document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').addEventListener("change", _CUSTOM_COD_FORM_PROVINCES.onProvinceChange);
    } catch (e) {
      console.log(e);
    }
  },
  onProvinceChange: function () {
    var value = document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value;

    var html = "";

    if (!_CUSTOM_COD_FORM_PROVINCES.data[value]) {
      html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value = "";
      return;
    }

    html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';

    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data[value]).sort().forEach(function (item) {
      html += '<option value="' + item + '">' + item + '</option>';
    });

    document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').innerHTML = html;
    document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value = "";
  }
};

function _COD_FORM_ON_OPEN_INIT_END_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE();
    }

    var html = "";

    html += '<option value="">' + _COD_FORM_PROVINCE_LABEL + '</option>';

    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data).sort().forEach(function (item) {
      html += '<option value="' + item + '">' + item + '</option>';
    });

    document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').innerHTML = html;

    _CUSTOM_COD_FORM_PROVINCES.startFields();
  } catch (e) {
    console.log(e);
  }
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE();
    }

    var onTimeout = function () {
      if (typeof _CUSTOM_COD_FORM_PROVINCES !== "undefined") {
        var html = "";

        html += '<option value="">' + _COD_FORM_PROVINCE_LABEL + '</option>';

        Object.keys(_CUSTOM_COD_FORM_PROVINCES.data).sort().forEach(function (item) {
          html += '<option value="' + item + '">' + item + '</option>';
        });

        document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').innerHTML = html;

        _CUSTOM_COD_FORM_PROVINCES.startFields();
      } else {
        setTimeout(onTimeout, 500);
      }
    }

    setTimeout(onTimeout, 500);
  } catch (e) {
    console.log(e);
  }
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE();
    }

    _COD_FORM_ON_OPEN_INIT_END_EMBEDDED();
  } catch (e) {
    console.log(e);
  }
}

var _COD_FORM_CITY_LABEL = "";
var _COD_FORM_PROVINCE_LABEL = "";

function _COD_FORM_OVERWRITE_INIT() {
  _rsi.s.form.fields.items_array.forEach(function (item) {
    if (item.type == "province_country_field" || item.type == "province") {
      item.type = "province_country_field";
      item.backendFields.name = "province";
      item.backendFields.elementType = "select";
      if (item.n) {
        if (item.n.ph) {
          _COD_FORM_PROVINCE_LABEL = item.n.ph;
        }
      }
      if (!_COD_FORM_PROVINCE_LABEL) {
        _COD_FORM_PROVINCE_LABEL = item.label;
      }
      item.backendFields.options = [{
        label: _COD_FORM_PROVINCE_LABEL,
        value: "",
      }];
    } else if (item.type == "city") {
      item.type = "city_country_field";
      item.backendFields.name = "city";
      item.backendFields.elementType = "select";
      if (item.n) {
        if (item.n.ph) {
          _COD_FORM_CITY_LABEL = item.n.ph;
        }
      }
      if (!_COD_FORM_CITY_LABEL) {
        _COD_FORM_CITY_LABEL = item.label;
      }
      var options = [{
        value: "", label: _COD_FORM_CITY_LABEL
      }];
      item.backendFields.options = options;
    }
  });

  try {
    if (typeof _COD_FORM_OVERWRITE_INIT_COVERAGE === "function") {
      if (!_COD_FORM_OVERWRITE_INIT_COVERAGE()) {
        return false;
      }
    }
  } catch (e) {
    console.log(e);
  }

  return true;
}